<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Stampa bollettini</h1>

    <loading-spinner v-if="loading" />
    <div
      v-else-if="$store.getters.isAuthenticated"
      class="row justify-content-between mx-2 mt-5 mb-2 align-middle"
    >
      <h4>Elenco bollettini</h4>
    </div>

    <b-alert
      v-if="!loading && !items.length"
      show
      variant="info"
      class="my-4"
    >
      Non ci sono bollettini da visualizzare.
    </b-alert>

    <b-table
      v-else-if="items.length"
      :per-page="perPage"
      :current-page="currentPage"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      :responsive="true"
      :busy="false"
    >
      <template v-slot:head(icon)>
        <font-awesome-icon
          icon="file-alt"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:head(button)>
        <font-awesome-icon
          icon="download"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(button)="data">
        <a
        v-if="data.item.pathBollettino !== null"
          :href="urlBollettino(data.item.AC_TESREV_ID)"
          target="_blank"
          @click.stop
          v-b-tooltip.hover
          title="Scarica il documento"
         
        >
          <font-awesome-icon
            v-if="data.item.button !== ''"
            icon="file-alt"
            size="lg"
            class="text-success cursor-pointer"
          />
        </a>
      </template>

    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </div>
      <div class="text-right">
        <b-form-group
          description="Per pagina"
          class="mb-0"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'LE_VERACT_ID', label: 'Codice RU', sortable: true },
        { key: 'AC_TIPDRE_DESCRIPTION', label: 'Documento', sortable: true },
        { key: 'FATATT_DATA_CONTABILIZZAZIONE', label: 'Competenza', sortable: true, formatter: (value) => { return moment(value, moment.ISO_8601).format('DD/MM/YYYY') } },
        { key: 'Scadenza', label: 'Scadenza', sortable: true, formatter: (value) => { return moment(value, 'YYYY/MM/DD').format('DD/MM/YYYY') } },
        { key: 'Importo', label: 'Importo Bollettino', sortable: true },
        'button'
      ],
      loading: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15]
    }
  },

  async created () {
    await this.load()
  },

  methods: {

    back () {
      this.$router.push({ name: 'home' })
    },

    async load () {
      try {
        this.loading = true
        await this.$store.dispatch('bollettini/loadItems')
        // console.log(this.$store)
        this.items = this.$store.state.bollettini.items
        this.totalRows = this.items.length || 0
        // console.log('this.totalRows', this.totalRows)

      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    urlBollettino (id) {
      return `/api/bollettini/${id}/download`
    }

  }
}
</script>
